import CreativeFileStatus from '@/Enums/Creatives/CreativeFileStatus.enum';
import CreativeType from '@/Enums/Creatives/CreativeType.enum';
import { ICreative } from '@/Interfaces/Creatives/Creative.interface';
import AudioPlayer from '@/components/AudioPlayer';
import TableActionButton from '@/components/Buttons/TableActionButton';
import ExportIcon from '@/components/Icons/ExportIcon';
import CreativePreviewModal from '@/pages/CreativeLibrary/Modals/CreativePreviewModal';
import { memo, useState } from 'react';

interface IProps {
  row: ICreative;
}

const PreviewCell = memo(({ row }: IProps) => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const notUploadedFileContent = (
    <p className='font-semibold'>{row.fileStatus === CreativeFileStatus.PROCESSING ? 'Processing' : 'Upload Failed'}</p>
  );

  switch (row.type) {
    case CreativeType.VIDEO:
    case CreativeType.DISPLAY:
      return [CreativeFileStatus.UPLOADED, CreativeFileStatus.STORED_IN_BEESWAX].includes(row.fileStatus) ? (
        <img className='h-full' src={row.thumbnail!} alt='thumbnail' />
      ) : (
        notUploadedFileContent
      );
    case CreativeType.VIDEO_VAST:
    case CreativeType.DISPLAY_TAG:
    case CreativeType.AUDIO_VAST:
      return row.tagContent ? (
        <>
          <TableActionButton variant='outlined' color='primary' onClick={() => setIsPreviewModalOpen(true)}>
            <ExportIcon className='w-[11px] mr-[4px]' />
            <span>Preview</span>
          </TableActionButton>
          <CreativePreviewModal
            open={isPreviewModalOpen}
            handleClose={() => setIsPreviewModalOpen(false)}
            name={row.name}
            type={row.type}
            tagContent={row.tagContent}
          />
        </>
      ) : (
        <p className='font-semibold'>No tag content</p>
      );
    case CreativeType.AUDIO:
      return [CreativeFileStatus.UPLOADED, CreativeFileStatus.STORED_IN_BEESWAX].includes(row.fileStatus) ? (
        <AudioPlayer src={row.file!} />
      ) : (
        notUploadedFileContent
      );
    default:
      return <p className='font-semibold'>Preview not available</p>;
  }
});

export default PreviewCell;
